module.exports = __webpack_public_path__ + "img/custom_link.ec437ce9.png";